import { Component, OnInit,NgZone } from '@angular/core';
import { cardAnimations } from 'src/app/utilities/animations';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedServiceService  } from 'src/app/services/shared-service.service';
import { GENERIC_ERRORS,ISTATACARD, TRACK_APPLICATION_URL_DECRYPT, base_https_url, VALIDATE_QDE_OTP_URL_DECRYPT, GENERIC_ERROR, IS_CAMPAIGN, TRACK_APP, verbiageList } from 'src/app/config/app-settings.config';
import { ThemeService } from 'src/app/services/theme.service';
import { EncrDecrService } from 'src/app/services/encr-decr-service.service';
import { QdeService } from 'src/app/services/qde.service';
import { xmlToJson, getDeviceSize } from 'src/app/utilities/utilities.file';
declare var _satellite: any;


@Component({
  selector: 'app-app-track',
  templateUrl: './app-track.component.html',
  styleUrls: ['./app-track.component.scss'],
  animations: [cardAnimations]
})
export class AppTrackComponent implements OnInit {
  resendOtp: boolean = false;
  // showTrackView: any = true;
  showTrackView: any = true;
  showOtpView: any;
  returnAnimation: any = false;
  showResendMsg: any = false;
  mobileNum: any;
  isTataCard: any = ISTATACARD;
  // router: any;
  sendOtpServiceError: any;
  applicationNum: any;
  trackApplicationServiceError: any;
  trackBtnDisabled: boolean = true;
  genericErrors: any = GENERIC_ERRORS;
  displayShortCodeHtml: boolean;
  otp: any;
  isMobile: boolean;
  isAnimationDisabled: boolean;
  otpCounter = 0;
  maxAttemptOtp: boolean = false;
  partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');
  domainUrl: any;
  optValidateCount: any = 0;
  otpValidationServiceError: string;

  constructor(
    private sharedData: SharedServiceService,
    private router: Router,
    private themeService: ThemeService,
    private encryptDecService:EncrDecrService,
    private qdeService: QdeService,
    private ngZone: NgZone
    ) {
      this.partnerCode = this.themeService.partnerCode;
    }

  ngOnInit() {
    this.domainUrl= base_https_url;
    this.showTrackView=this.sharedData.showTrackView;
    this.showOtpView = this.sharedData.showOtpViewTrack;
    this.isAnimationDisabled = true;
    this.mobileNum = this.themeService.trackMob;
    if (getDeviceSize() === 'small') {
      this.isMobile = true;
    } 
    window.onresize = (e) => {
      this.ngZone.run(() => {
        if (getDeviceSize() === 'small') {
          this.isMobile = true;
        } else {
          
          this.isMobile = false;
        }
      });
    };
  }
  
  trackButtonClick() {
  
    console.log("Running "+ this.isMobile); 
    console.log("applicationNum "+ this.applicationNum); 
    console.log("leadRefNo "+ this.applicationNum); 

  
    this.isAnimationDisabled =  false;
    let request = {
      "applicationNumber": this.applicationNum,
      "leadRefNo": this.applicationNum
    }
    console.log(this.mobileNum);
   this.sharedData.trackApplication(request).subscribe((response: any) => {
    let result :any;
    if (response) {
      result = TRACK_APPLICATION_URL_DECRYPT ? { ...this.encryptDecService.get(response.body) } : { ...response.body };
      console.log(result);
    }
     if(result){
       if(result.eapplyApplicantDetails && result.eapplyApplicantDetails.mobileNumber){
        let accessToken: any;
        let expiryTime: any;
        if (response.headers && response.headers.get("access_token")) {
          accessToken = response.headers.get("access_token");
          console.log("accesstoken:", accessToken);
        }
        if (response.headers && response.headers.get("expiry_time")) {
          expiryTime = response.headers.get("expiry_time");
          console.log("Time:", expiryTime);
        }

        if (accessToken) {
          sessionStorage.setItem("s24_access_token", accessToken);
        }
        if (expiryTime) {
          sessionStorage.setItem("s24_expiry_time", expiryTime);
        }
        // this.sharedData.paramsappNumber = this.applicationNum;
        this.mobileNum = result.eapplyApplicantDetails.mobileNumber;
        this.themeService.trackMob = this.mobileNum;
        this.sharedData.trackApplicationResponse = result;
        this.sharedData.applicantApplicationNumber = result.applicationNumber;
        this.sharedData.applicantName = result.eapplyApplicantDetails.firstName;

        this.sharedData.navigateToCompleteApp = result.enableDataCaptureFlag;
        this.sharedData.navigateToDocUpload =  result.enableDocumentListFlag;
        this.sharedData.navigateToScheduleAppointment = result.enableAppointmentFlag;
        this.sharedData.navigateToAddon = result.enableAddOnListFlag;
        this.sharedData.navigateToCrossSell = result.enableCrossSellFlag;
        this.sharedData.navigateToResheduleAppointment = result.enableReSchdAppointmentFlag;
        this.sharedData.sbic_card_Type = result.cardType;
        let channelCode = result.channelCode ? result.channelCode : '';

        if (channelCode) {
          if (channelCode == "EALB") {
            this.sharedData.paramschannel = '901';
            sessionStorage.setItem('channelId','901');
          } else if (channelCode == "EABP") {
            this.sharedData.paramschannel = '701';
            sessionStorage.setItem('channelId','701');
          }
        }

        if (IS_CAMPAIGN) {
          window["digitalData"].page = { pageName: 'sbi-card:eapply:campaign', pageType: 'Campaign' };
        } else {
          window["digitalData"].page = { pageName: 'sbi-card:eapply:track', pageType: 'Eapply' };
        }
        window["digitalData"].decisionType = this.sharedData.trackApplicationResponse.statusCode;
        window["digitalData"].instantDecision = this.sharedData.trackApplicationResponse.statusDescription;
        window["digitalData"].eapply = { number: this.sharedData.applicantApplicationNumber };
        window["digitalData"].application = { status: "complete" };
        if (this.sharedData.cardName) {
          window["digitalData"].card = { cardName: this.sharedData.cardName };
        }
       // _satellite.track("track_application");
        this.sendOtpForValidation(this.mobileNum, false);

        // this.sharedData.showTrackView=false;
        // this.sharedData.showOtpViewTrack=true;
        // this.showTrackView = false;
        // this.showOtpView = true;

       }else if(result.status && result.status.toLowerCase() == 'failure' && result.errorMessage){
        this.trackApplicationServiceError = result.errorMessage;
        //  this.router.navigate(['track-partner-error'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType?true:false });
     
       }else {
        this.trackApplicationServiceError = this.genericErrors.genError;
        // this.router.navigate(['track-partner-error'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType?true:false });
       }
       
     }
     else{
      this.trackApplicationServiceError = this.genericErrors.genError;
      //  this.router.navigate(['track-partner-error'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType?true:false });
     }
   },
   
   error => {
    console.log("Error has occured:", error);
    this.trackApplicationServiceError = this.genericErrors.genError;
    //  this.router.navigate(['track-partner-error'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType?true:false });
  });
 //this.router.navigate(['/', 'track-app-partner'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType ? true : false });
  
  }

  cancelClick() {
    this.isAnimationDisabled =  false;
    
    this.sharedData.showTrackView=true;
    // this.sharedData.showTrackViewOnCancel=true;
    this.sharedData.showOtpViewTrack=true;

    // this.returnAnimation = true;
    this.showTrackView = true;
    // this.showTrackViewOnInit = false;
    this.showOtpView = false;
  }
  resendClick() {
    if(!this.maxAttemptOtp){
      this.sendOtpForValidation(this.mobileNum, true);
    }
    
    // this.showResendMsg = true;
    // setTimeout(() => { this.showResendMsg = false; }, 2000);
  }

  onApplicationNumChange(){
    this.trackApplicationServiceError = false;
    if(this.applicationNum.length>=11){
      this.trackBtnDisabled = false;
    }
    else{
      this.trackBtnDisabled = true;
    }
  }

  sendOtpForValidation(mobileNum, flag) {
    if (this.otpCounter >= 5) {
      return;
    }
    if (flag) {
      this.resendOtp = true;
      setTimeout(() => {
        this.resendOtp = false;
      }, 3000)
    }
    let reasonCode: any;
    if (this.applicationNum) {
      // reasonCode = '132';
      reasonCode = '160';
    } else {
      // reasonCode = '121';
      reasonCode = '161';
    }
    console.log('reasoncode: ', reasonCode);

    this.sharedData.sendOtp(mobileNum, '', flag, reasonCode).subscribe((result: any) => {
      console.log(result)
      if(result){
        if(result.OTPGenerationRsType && result.OTPGenerationRsType.status && result.OTPGenerationRsType.status.toLowerCase() == "success" && result.OTPGenerationRsType.statusCode === "000"){
          // this.displayShortCodeHtml = false;
          this.sharedData.showTrackView=false;
          this.sharedData.showOtpViewTrack=true;
          this.showTrackView = false;
          this.showOtpView = true;
          this.trackBtnDisabled = true;
          console.log("otp send for retrive or track application");
          this.themeService.trackMob = this.mobileNum;
          this.showResendMsg = true;
          this.otpCounter = this.otpCounter + 1;
          this.otp='';
          (this.otpCounter == 5) ? this.maxAttemptOtp = true : this.maxAttemptOtp = false;
            setTimeout(() => { this.showResendMsg = false; }, 2000);
          } else {
          this.trackApplicationServiceError = this.genericErrors.sendOtpError;
          //  this.router.navigate(['track-partner-error'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType?true:false });
           window["digitalData"].error = { message: GENERIC_ERROR };
          _satellite.track('form_error');
        } 

      }else{
        this.trackApplicationServiceError = this.genericErrors.sendOtpError;
        //  this.router.navigate(['track-partner-error'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType?true:false });
         window["digitalData"].error = { message: GENERIC_ERROR };
        _satellite.track('form_error');
      }
    },
      error => {
        console.log("Error has occured:", error);
        //  this.router.navigate(['track-partner-error'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType?true:false });
        this.trackApplicationServiceError = this.genericErrors.sendOtpError;
        window["digitalData"].error = { message: GENERIC_ERROR };
        _satellite.track('form_error');
      }
    )

  }

  validateOtp(otp, mobileNumber) {
    this.trackApplicationServiceError = false;
    // console.log(otp)
    if (otp && otp.length < 6) {
      //  console.log(otp.length)
      return
    } else if (otp && otp.length == 6) {
      const requestBody = {
        cardNumber: '000' + mobileNumber + '999999',
        otp: otp || null,
        reasonCode: '160',
        mobileNumber: ''+ mobileNumber,
        dsignString: this.sharedData.uuidString
        
      }
      let reasonCode: any;
      if (this.applicationNum) {
        reasonCode = '160';
      } else {
        reasonCode = '161';
      }
      this.sharedData.validateOtp(requestBody, reasonCode).subscribe((res: any) => {
        if(res){
          res = VALIDATE_QDE_OTP_URL_DECRYPT ? this.encryptDecService.get(res) : res;
          console.log("response of otp validation" + res)
        }
        if (res && res.OtpValidationRsType && res.OtpValidationRsType.status && res.OtpValidationRsType.status.toLowerCase() == "success" && res.OtpValidationRsType.statusCode === "000" && res.OtpValidationRsType.dsignString === this.sharedData.uuidString) {
          _satellite.track("mobile_number_verify");
          // this.otpValidationServiceError = '';
          // this.sendOtpServiceError = '';
          this.optValidateCount += 1;
          if (res.OtpValidationRsType.signedValue) {
            this.qdeService.signedValueResponse = res.OtpValidationRsType.signedValue;
          }
          
          if (this.applicationNum && res.OtpValidationRsType.mobileNumber == this.mobileNum) {
            this.router.navigate(['/apply', 'track-app'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType?true:false });
          } else {
            this.sharedData.abortMessage = TRACK_APP.trackError;
            // this.router.navigate(['track-partner-error'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType?true:false });
            this.trackApplicationServiceError = 'please enter valid OTP';
          }
        } else {
          console.log("otp is incorrect")
          this.optValidateCount += 1;
          this.otpValidationServiceError = verbiageList.invalidOtp;
          this.otp = '';
          //  this.router.navigate(['track-partner-error'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType?true:false });
          this.trackApplicationServiceError = verbiageList.invalidOtp;;
          window["digitalData"].error = { message: GENERIC_ERROR };
        }
      },
      (error) => {
        console.log("Error has occured:", error);
        this.otp = '';
        //  this.router.navigate(['track-partner-error'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType?true:false });
        this.trackApplicationServiceError = this.genericErrors.sendOtpError;
        window["digitalData"].error = { message: GENERIC_ERROR };
      });
    }
  }

  numberOnly(event) {
    let regex2 = /[0-9]/;
    if (event.key.match(regex2)) {
      return true;
    } else {
      return false;
    }
  }
}
